import { fork, put, takeLatest } from 'redux-saga/effects';

import { TOKENS_LOCAL_STORAGE_KEY } from '../../../constants';
import * as tokensModule from '../tokens';
import { actions, types } from './duck';

// Cookie read by nginx: present = logged in = serve the CRA app; absent = serve the Next.js app.
const AUTH_COOKIE = 'cb_auth';
const AUTH_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

const setAuthCookie = () => {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  document.cookie = `${AUTH_COOKIE}=1; path=/; max-age=${AUTH_COOKIE_MAX_AGE_SECONDS}; samesite=lax${secure}`;
};

const clearAuthCookie = () => {
  if (typeof document === 'undefined') return;
  document.cookie = `${AUTH_COOKIE}=; path=/; max-age=0; samesite=lax`;
};

export function* saveAuthWebSaga({ tokens }) {
  const tokensJson = JSON.stringify(tokens);
  localStorage.setItem(TOKENS_LOCAL_STORAGE_KEY, tokensJson);
  setAuthCookie();
  yield put(actions.saveAuthSuccess(tokens));
}

export function* restoreAuthWebSaga() {
  const tokensJson = localStorage.getItem(TOKENS_LOCAL_STORAGE_KEY);
  if (tokensJson) {
    let tokens;
    try {
      tokens = JSON.parse(tokensJson);
    } catch (error) {
      localStorage.removeItem(TOKENS_LOCAL_STORAGE_KEY);
      clearAuthCookie();
      yield put(actions.restoreAuthFailure('Stored tokens were corrupted.'));
      return;
    }
    setAuthCookie();
    yield put(tokensModule.actions.setTokens(tokens));
    yield put(actions.restoreAuthSuccess(tokens));
  } else {
    clearAuthCookie();
    yield put(actions.restoreAuthFailure('Storage is empty.'));
  }
}

export function* forgotAuthWebSaga() {
  localStorage.removeItem(TOKENS_LOCAL_STORAGE_KEY);
  clearAuthCookie();
  yield put(actions.forgotAuthSuccess());
}

export function* runRestore() {
  yield put(actions.restoreAuth());
}

export default function* saga() {
  yield takeLatest(types.SAVE_AUTH, saveAuthWebSaga);
  yield takeLatest(types.RESTORE_AUTH, restoreAuthWebSaga);
  yield takeLatest(types.FORGOT_AUTH, forgotAuthWebSaga);

  // Integration listeners
  yield takeLatest(tokensModule.types.SET_TOKENS, saveAuthWebSaga);
  yield takeLatest(tokensModule.types.CLEAR_TOKENS, forgotAuthWebSaga);

  // Restore auth on initialize.
  yield fork(runRestore);
}